import './i18n.init';
import Vue from 'vue';
import MTD from '@ss/mtd-vue';
import '@ss/mtd-vue/lib/theme2/index.css';
import mcfe from '@osgfe/components';
/**
 * 不装这个包样式会出现问题，后续期望mcfe-components来解决此问题，毕竟子项目并没有直接依赖@bfe/mtd-theme-582这个包
 */
// eslint-disable-next-line import/no-extraneous-dependencies
import '@bfe/mtd-theme-582/index.css';
import '@osgfe/components/lib/theme2/index.css';

import { createErrorOverlay } from '@osgfe/runtime-error-overlay';

import { i18nPlugin } from '@sailor/i18n-vue';
import ChainedBackend from 'i18next-chained-backend';
import OpenAPIBackend from '@sailor/i18n-web-openapi-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import requestPlugin from './plugins/request';
import resources from './assets/locales/resources';

const isProduction = process.env.NODE_ENV === 'production';

export default function (App) {
    Vue.use(MTD);
    Vue.use(mcfe);
    Vue.use(requestPlugin);

    Vue.use(i18nPlugin, (i18nClient) => {
        i18nClient.use(ChainedBackend).init({
            fallbackLng: 'en',
            backend: {
                // 通过 api 获取最新语言包
                backends: [OpenAPIBackend, resourcesToBackend(resources)],
                // 这里配置一下所使用的 projectId 和 namespaceId
                backendOptions: [
                    {
                        env: isProduction ? 'prod' : 'test',
                        namespaces: [
                            {
                                // i18n 平台对应项目 id
                                projectId: 43,
                                // i18n 平台对应的项目 apiKey
                                apiKey: '5960afab14104e319ab1a7db5057e908',
                                // i18n 平台对应的空间 id（经 hash 处理的 id ）
                                namespaceId: 'qjpecyxapi',
                            },
                        ],
                    },
                ],
            },
        });
    });


    window.Vue = Vue;
    if (process.env.NODE_ENV === 'development') {
        Vue.config.errorHandler = function (err) {
            createErrorOverlay(err);
        };
    }
    // eslint-disable-next-line no-new
    new Vue({
        el: '#app',
        render(h) {
            return h(App);
        },
    });
}
